// «Поделиться»: системное меню или копирование ссылки
import { toast } from '../ui/Toast';

export async function share(url: string, title: string): Promise<void> {
  if (navigator.share) {
    try {
      await navigator.share({ url, title });
      return;
    } catch (err) {
      if (err instanceof Error && err.name === 'AbortError') return;
    }
  }
  try {
    await navigator.clipboard.writeText(url);
    toast('Ссылка скопирована');
  } catch {
    prompt('Скопируйте ссылку:', url);
  }
}
